module.exports = __webpack_public_path__ + "b914709691601e363c1958449867a486.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/popcorn-s.png
// module id = 2586
// module chunks = 0